(function () {
  const page_header_slider_v2_list = document.querySelectorAll('.js_page_header_slider_v3')

  for (let i = 0; i < page_header_slider_v2_list.length; i++) {
    const slider = page_header_slider_v2_list[i]
    const totalSlides = slider.querySelectorAll('.swiper-slide').length;
    initPageHeaderSliderV3(slider, totalSlides)
  }

  function initPageHeaderSliderV3 (slider, totalSlides) {
    const sliderWrapEl = slider.closest('.page-header-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let isLoop = true
    const slidesCount = sliderWrapEl.querySelectorAll('.swiper-slide').length
    if (slidesCount === 1) {
      isLoop = false
      sliderWrapEl.classList.add('one-slide-slider')
    } else {
      sliderWrapEl.classList.remove('one-slide-slider')
    }

    // hide arrows if they are disabled
    if (totalSlides === 1) {
      swiperButtonNext.style.opacity = 0;
      swiperButtonPrev.style.opacity = 0;
    }

    // show arrows on desktop size and if they're not disabled
    if (window.innerWidth >= 768 && totalSlides !== 1) {
      swiperButtonNext.setAttribute('style', 'display:flex !important');
      swiperButtonPrev.setAttribute('style', 'display:flex !important');
    }

    let sliderOptions = {
      watchOverflow: true,
      slidesPerView: 1,
      loop: isLoop,
      autoHeight: !sliderWrapEl.classList.contains('one-slide-slider'),
      // pagination: {
      //   el: swiperPagination,
      //   clickable: true,
      //   dynamicBullets: true,
      // },
      navigation: {
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrev,
      },
      on: {
        transitionStart: function () {
          var videos = slider.querySelectorAll('.js_page_header_slider_video')

          Array.prototype.forEach.call(videos, function (video) {
            video.pause()
          })
        },

        transitionEnd: function () {
          var activeIndex = this.activeIndex
          var activeSlide = slider.querySelectorAll('.js_page_header_slider_v3 .swiper-slide')[activeIndex]
          var activeSlideVideo = activeSlide.getElementsByTagName('video')[0]
          if (activeSlideVideo) {
            activeSlideVideo.play()
          }
        },
      }
    }

    // Conditionally add pagination if isLoop is true
    if (isLoop) {
      sliderOptions.pagination = {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: true,
      };
    }

    new Swiper(slider, sliderOptions)
  }

})()
